export default "__VITE_ASSET__3c21f7df__"